export function getFirstLetterOfBaseDomain(domainOrSubdomain: string) {
    const domainOrSubdomainParts = domainOrSubdomain.split('.');

    if (domainOrSubdomainParts.length > 2) {
        return domainOrSubdomainParts[1].slice(0, 1).toUpperCase();
    }

    return domainOrSubdomain.slice(0, 1).toUpperCase();
}
